/*
 * @Author: qian.tang
 * @Date: 2023-08-25 21:00:14
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-10-19 15:58:08
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\AllocationAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";


const AllocationAPI = {

  getAllocationOverview: async () => {
    try {
      const url = `${getBizCode()}/allocation`
      const res = await AM_API.get(url)
      console.log('getAllocationOverview res', res)
      return res.data.allocation_overview
    } catch (e) {
      logError(e)
      throw e
    }


  },
  getAllocationHistoryById: async (assetId: string) => {
    try {
      const url = `${getBizCode()}/allocation?asset_history=${assetId}`
      const res = await AM_API.get(url)
      console.log('getAllocationHistoryById res', res)
      const result = res.data.Items
      return result
    } catch (e) {
      logError(e)
      throw e
    }


  },
  allocateAsset: async (payload: any) => {
    try {
      const res = await AM_API({
        url: `${getBizCode()}/allocation`,
        method: 'POST',
        data: payload
      })

      return res

    } catch (e) {
      logError(e)
      console.log('allocateAsset fail...', e)
      throw e
    }


  },
  // updateAllocationRequest: async (payload: any) => {
  //   try {
  //     const res = await AM_API({
  //       url: base,
  //       method: 'PUT',
  //       data: payload
  //     })
  //     return res
  //   } catch (e) {
  //     logError(e)
  //     console.log('updateAllocationRequest fail...', e)
  //     throw e
  //   }

  // },

}

export default AllocationAPI